import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';
import { useAssignDesignInputDesignSpec } from '../Product.hooks';

import {
  ProductDesignSpec,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignDesignSpecDialog from './AssignDesignSpecDialog';

export type DesignInputAssignDesignSpecDialogProps =
  BaseProductAssignDialogProps<'designInputId'>;

const DesignInputAssignDesignSpecDialog: React.FC<DesignInputAssignDesignSpecDialogProps> =
  (props: DesignInputAssignDesignSpecDialogProps) => {
    const {
      open,
      productId,
      designInputId,
      selectedItems,
      onCancel,
      onError,
      onAssigned
    } = props;
    const {
      updatedProductDesignInput,
      isAssigning,
      error: assignError,
      assignDesignSpecs
    } = useAssignDesignInputDesignSpec(productId, designInputId);

    // handle notification to parent after assigning
    useEffect(() => {
      if (updatedProductDesignInput) {
        onAssigned?.(updatedProductDesignInput);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updatedProductDesignInput]);

    useEffect(() => {
      if (assignError) {
        onError?.(assignError);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assignError]);

    return (
      <AssignDesignSpecDialog
        {...{ open, productId, selectedItems, onCancel, onError }}
        isLoading={isAssigning}
        contentText={`Search for ${getProductEntityName(
          'designSpec'
        )} to assign to the ${getProductEntityName('designInput')}.`}
        onSubmit={(designSpecs: ProductDesignSpec[]) => {
          assignDesignSpecs({
            designSpecIds: designSpecs.map(
              (designSpec: ProductDesignSpec) => designSpec.id
            )
          });
        }}
      />
    );
  };

export default DesignInputAssignDesignSpecDialog;
